import type { TComment } from "../types";

export const comments: TComment[] = [
  {
    id: 1,
    name: "مجید زارعی‌پور",
    text: [
      "تو این مینی‌دوره در قالب ۳ فصل، نقشه راه رشد سریع صدات رو بهت نشون دادم.",
      "وقتی به آخر ویدیوی سوم برسی، آماده‌ای برای برداشتن یک قدم جدی برای رشد صدات.",
    ],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 2,
    name: "فرناز خاکیان‌زاده",
    text: [
      "من همیشه از ضبط صدام استرس داشتم ولی با تمرین‌های این دوره تونستم پیشرفت کنم!",
      "الان اعتماد به نفسم تو ضبط خیلی بیشتر شده.",
    ],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 3,
    name: "حمید رحیمی",
    text: [
      "خیلی خوشحالم که با این دوره آشنا شدم، واقعا مفید بود.",
      "آموزش‌ها کاملاً کاربردی و واضح هستن.",
    ],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 4,
    name: "سارا نادری",
    text: [
      "من از صفر شروع کردم ولی با این مینی‌دوره تونستم پایه صدامو قوی‌تر کنم.",
      "منتظر دوره‌های بعدیتون هستم!",
    ],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 5,
    name: "علیرضا نعمتی",
    text: [
      "تمرین‌های عملی فوق‌العاده‌ان، باعث شد صدای خودمو بهتر کنترل کنم.",
      "واقعا ممنون از آموزش‌های دقیق و قابل فهم.",
    ],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 6,
    name: "نگین کریمی",
    text: [
      "من تو خوانندگی تازه‌کارم ولی با همین مینی‌دوره دیدم خیلی باز شد!",
      "نکات ریز و طلایی‌ای گفتین که هیچ جا نشنیده بودم.",
    ],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 7,
    name: "رضا طهماسبی",
    text: [
      "واقعا از طرز آموزش استاد لذت بردم. صدا و بیانم خیلی بهتر شده.",
      "به همه توصیه می‌کنم شرکت کنن.",
    ],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 8,
    name: "مریم رادمنش",
    text: [
      "پشتیبانی خیلی خوبی داشت و همه سوالام پاسخ داده شد.",
      "با همین دوره تونستم اولین ضبط حرفه‌ای خودمو انجام بدم!",
    ],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  // اضافه کردن آیتم‌های جدید تا 30
  {
    id: 9,
    name: "امیر حسینی",
    text: ["دوره خیلی کاربردی بود.", "استاد عالی توضیح دادند."],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 10,
    name: "لیلا مرادی",
    text: ["با این تمرین‌ها پیشرفت کردم.", "خیلی راضی هستم."],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 11,
    name: "سعید احمدی",
    text: ["تجربه خیلی خوبی بود.", "همه چیز واضح و روان بود."],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 12,
    name: "نگار رضایی",
    text: ["تمرین‌ها عالی بودن.", "خیلی چیزهای جدید یاد گرفتم."],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 13,
    name: "مهیار کریمی",
    text: ["آموزش‌ها خیلی مفید بود.", "حتماً به دیگران هم توصیه می‌کنم."],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 14,
    name: "فاطمه نادری",
    text: ["پشتیبانی عالی بود.", "همه سوال‌ها پاسخ داده شد."],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 15,
    name: "حسن طهماسبی",
    text: ["با تمرین‌ها خیلی پیشرفت کردم.", "واقعا ممنون از دوره."],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 16,
    name: "مهسا رادمنش",
    text: ["استاد بسیار مسلط و حرفه‌ای بود.", "همه چیز رو کامل توضیح دادند."],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 17,
    name: "علی زارعی",
    text: ["دوره مفید و کاربردی بود.", "تجربه خوبی کسب کردم."],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 18,
    name: "سارا احمدی",
    text: ["تمرین‌ها واقعا کاربردی بودن.", "خیلی چیز یاد گرفتم."],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 19,
    name: "رضا کریمی",
    text: ["آموزش‌ها روان و واضح بود.", "خیلی خوب توضیح داده شد."],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 20,
    name: "مهتاب حسینی",
    text: ["دوره خیلی مفید بود.", "تمرین‌ها عالی بودن."],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 21,
    name: "امیر نادری",
    text: ["تجربه خوبی بود.", "استاد خیلی مسلط بود."],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 22,
    name: "لیلا طهماسبی",
    text: ["با تمرین‌ها خیلی پیشرفت کردم.", "خیلی راضی هستم."],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 23,
    name: "سعید مرادی",
    text: ["دوره کاربردی و عالی بود.", "همه چیز رو کامل توضیح دادند."],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 24,
    name: "نگار احمدی",
    text: ["آموزش‌ها فوق‌العاده بودن.", "خیلی چیز یاد گرفتم."],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 25,
    name: "مهیار رضایی",
    text: ["دوره عالی بود.", "تمرین‌ها خیلی مفید بودن."],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 26,
    name: "فاطمه کریمی",
    text: ["استاد خیلی مسلط بود.", "همه چیز واضح توضیح داده شد."],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 27,
    name: "حسن زارعی",
    text: ["تمرین‌ها فوق‌العاده بودن.", "خیلی راضی هستم."],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 28,
    name: "مهسا احمدی",
    text: ["دوره کاربردی بود.", "خیلی چیز یاد گرفتم."],
    avatar: "/images/avatar_3.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 29,
    name: "علی کریمی",
    text: ["آموزش‌ها خیلی مفید بودن.", "تمرین‌ها عالی بودن."],
    avatar: "/images/avatar_4.png",
    mainImage: "/images/current_user.png",
  },
  {
    id: 30,
    name: "سارا حسینی",
    text: ["با این دوره خیلی پیشرفت کردم.", "واقعا تجربه خوبی بود."],
    avatar: "/images/avatar_2.png",
    mainImage: "/images/current_user.png",
  },
];
